export default "__VITE_ASSET__edbf2cb0__"